'use client';

import React from 'react';

import {TransactionalCTAButton} from '@/features/course-landing-page/components/transactional-cta-button/transactional-cta-button.react-component';

import styles from './enrolled-sticky-footer-content.module.scss';

/**
 * EnrolledStickyFooterContent component displays only a CTA button for enrolled users.
 * This provides a simple action for users who are already enrolled in the course.
 */
export const EnrolledStickyFooterContent: React.FC = () => {
    return (
        <TransactionalCTAButton className={styles['transactional-cta-button']} udStyle="primary" />
    );
};
